import { FetchResult, MutationResult, gql, useMutation } from '@apollo/client';

import {
  UpdateSurvey,
  UpdateSurveyVariables,
} from 'src/lib/graphqlTypes/types';

import { generateSurveyState } from '../views/userProfileSurvey/helpers';

export const updateSurveyMutation = gql<UpdateSurvey, UpdateSurveyVariables>`
  mutation UpdateSurvey(
    $orgId: String!
    $surveyId: String!
    $surveyState: [SurveyQuestionInput!]!
    $surveyIdVersion: Int!
  ) {
    updateSurvey(
      internalAccountId: $orgId
      surveyId: $surveyId
      surveyState: $surveyState
      surveyIdVersion: $surveyIdVersion
    ) {
      id
      questionAnswers {
        questionKey
        answerValue
      }
    }
  }
`;

/*
 * Custom hook that handles massaging form values into the correct format for the
 * updateSurvey mutation.
 */
export const useUpdateSurveyMutation = (): [
  (
    rawValues: Omit<UpdateSurveyVariables, 'surveyState'> & {
      surveyState: Record<string, string | undefined | null>;
    },
  ) => Promise<FetchResult<UpdateSurvey>>,
  MutationResult<UpdateSurvey>,
] => {
  const [updateSurvey, result] = useMutation(updateSurveyMutation);
  const callback = async (
    rawValues: Omit<UpdateSurveyVariables, 'surveyState'> & {
      surveyState: Record<string, string | undefined | null>;
    },
  ) => {
    const variables = {
      ...rawValues,
      surveyState: generateSurveyState(rawValues.surveyState),
    };

    return updateSurvey({ variables });
  };

  return [callback, result];
};
